module.exports = __webpack_public_path__ + "img/17exp.a71bc6c0.jpg";